import { ArrowRight, HeadCircuit, Heartbeat, Suitcase } from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import { UseHomePageReturn } from '../hooks/useHomePage';
import locale from '../locale.json';
import { useHomePageSharedStyles } from '../HomePage.styles';
import { useHomePageInnovativeToolsSectionStyles } from './HomePageInnovativeToolsSection.styles';

type HomePageInnovativeToolsSectionProps = {
  state: Pick<UseHomePageReturn, 'openLifestylemetriQ' | 'openJobOffers' | 'openCoachIA'>;
};

type InnovativeCard = {
  key: string;
  title: string;
  description: string;
  availability?: string;
  icon: Icon;
  onClick: () => void;
};

const HomePageInnovativeToolsSection = ({ state }: HomePageInnovativeToolsSectionProps) => {
  const shared = useHomePageSharedStyles();
  const local = useHomePageInnovativeToolsSectionStyles();
  const classes = { ...shared, ...local };
  const { openLifestylemetriQ, openJobOffers, openCoachIA } = state;

  const cards: InnovativeCard[] = [
    {
      key: 'lifestylemetriq',
      title: locale.innovativeLifestyleTitle,
      description: locale.innovativeLifestyleDescription,
      availability: locale.innovativeLifestyleAvailability,
      icon: Heartbeat,
      onClick: openLifestylemetriQ,
    },
    {
      key: 'coach',
      title: locale.innovativeCoachTitle,
      description: locale.innovativeCoachDescription,
      icon: HeadCircuit,
      onClick: openCoachIA,
    },
    {
      key: 'jobs',
      title: locale.innovativeJobsTitle,
      description: locale.innovativeJobsDescription,
      icon: Suitcase,
      onClick: openJobOffers,
    },
  ];

  return (
    <section className={classes.sectionWhite}>
      <div className={classes.sectionIntro}>
        <p className={classes.sectionLabel}>{locale.innovativeLabel}</p>
        <h2 className={classes.sectionTitle}>{locale.innovativeTitle}</h2>
        <p className={classes.sectionDescription}>{locale.innovativeDescription}</p>
      </div>

      <div className={classes.innovativeGrid}>
        {cards.map(card => (
          <button
            key={card.key}
            type="button"
            className={classes.innovativeCard}
            onClick={card.onClick}>
            <div className={classes.innovativeIconWrap}>
              <card.icon className={classes.innovativeIcon} aria-hidden="true" />
            </div>
            <div className={classes.innovativeContent}>
              <h3 className={classes.innovativeTitle}>{card.title}</h3>
              <p className={classes.innovativeDescription}>
                {card.description}
                {card.availability && (
                  <>
                    <br />
                    <span className={classes.innovativeAvailability}>{card.availability}</span>
                  </>
                )}
              </p>
              <div className={classes.innovativeFooter}>
                <span className={classes.innovativeArrowWrap}>
                  <ArrowRight className={classes.arrowIcon} aria-hidden="true" />
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default HomePageInnovativeToolsSection;
